import {
  isString,
  isEmpty,
} from '@/helpers/is';
import { Button } from '@mantine/core';

/**
 * transform to clickable text (looks like text but acts as a button)
 * @param {string} d
 * @param {object} params
 * @param {object} row - the full row data
 * @returns {react}
 */
const buttonTransform = (d, params = {}, row = {}) => {
  if (!isString(d) || isEmpty(d)) { return ''; }

  const {
    onClick,
  } = params;

  const handleClick = () => {
    if (onClick) {
      onClick(row);
    }
  };

  return (
        <Button onClick={handleClick} variant='transparent' size='xs'>
          {d}
        </Button>
  );
};

export default buttonTransform;
